import { render, staticRenderFns } from "./MilestoneDetail.vue?vue&type=template&id=753bf8a8&scoped=true&"
import script from "./MilestoneDetail.vue?vue&type=script&lang=js&"
export * from "./MilestoneDetail.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneDetail.vue?vue&type=style&index=0&id=753bf8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753bf8a8",
  null
  
)

export default component.exports